<template>
    <ModalFormCard class="modal-default lg:!w-[500px]">
        <template #title>{{ $en.crm.funds }}</template>

        <template #default="{ saving, errors }"> </template>
    </ModalFormCard>
</template>
